module.exports = __webpack_public_path__ + "img/fachu.9ade1cce.png";